/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Authstartsentbody3Inputs */

const en_authstartsentbody3 = /** @type {(inputs: Authstartsentbody3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We sent a one-click sign-in link to ${i?.email}. Click it to create your account and pick up where the diagnostic left off — your answers are waiting.`)
};

const pt_authstartsentbody3 = /** @type {(inputs: Authstartsentbody3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enviámos um link de acesso de um clique para ${i?.email}. Clique para criar a conta e retomar onde deixou — as suas respostas estão à espera.`)
};

/**
* | output |
* | --- |
* | "We sent a one-click sign-in link to {email}. Click it to create your account and pick up where the diagnostic left off — your answers are waiting." |
*
* @param {Authstartsentbody3Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const authstartsentbody3 = /** @type {((inputs: Authstartsentbody3Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Authstartsentbody3Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_authstartsentbody3(inputs)
	return pt_authstartsentbody3(inputs)
});
export { authstartsentbody3 as "authStartSentBody" }